/**
 * Compares two numbers for equality after rounding to a given number of decimal places.
 * Avoids false negatives from floating-point representation errors (e.g. `0.1 + 0.2 !== 0.3`).
 */
export function numbersEqual(a: number, b: number, decimals = 5): boolean {
  const factor = 10 ** decimals
  return Math.round(a * factor) === Math.round(b * factor)
}

/**
 * Rounds a dispensing quantity onto the 2-decimal grid the API contracts
 * enforce (`multipleOf(0.01)` on `batchAllocationItemSchema` and friends).
 *
 * Stock quantities are stored as float8 and mutated in place by repeated
 * `± quantity` writes, so live rows drift off that grid (1.77 comes back as
 * 1.7699999999999996). Any quantity we *derive* rather than take from user
 * input has to be re-rounded before it's sent to the server, or validation
 * rejects it.
 */
export function roundQuantity(value: number): number {
  return Math.round(value * 100) / 100
}
